import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/startTournament';
import { fetchRequest as fetchTournament } from '../../actions/discovery/tournament';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId, retrainPolicy } = action?.payload || {};
    const body = retrainPolicy ? { retrain_policy: retrainPolicy } : {};
    const response = yield call(
      axios.post,
      `${config.API_URL}/goals/${goalId}/train`,
      body,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
    // Refresh the leaderboard immediately so the UI shows "queued".
    yield put(fetchTournament({ goalId }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
